const drawings = [
  new URL('../assets/cats/loaf.svg', import.meta.url),
  new URL('../assets/cats/sleepy-noodle.svg', import.meta.url),
  new URL('../assets/cats/big-stretch.svg', import.meta.url),
  new URL('../assets/cats/peeking.svg', import.meta.url),
  new URL('../assets/cats/fluffy-himalayan.svg', import.meta.url),
  new URL('../assets/cats/sleepy-himalayan.svg', import.meta.url),
  new URL('../assets/cats/sitting-tall.svg', import.meta.url),
  new URL('../assets/cats/belly-up.svg', import.meta.url),
  new URL('../assets/cats/waving-paw.svg', import.meta.url),
  new URL('../assets/cats/cardboard-cat.svg', import.meta.url),
  new URL('../assets/cats/yarn-tangle.svg', import.meta.url),
  new URL('../assets/cats/sneaky-cat.svg', import.meta.url),
  new URL('../assets/cats/over-the-shoulder.svg', import.meta.url),
  new URL('../assets/cats/long-tail.svg', import.meta.url),
  new URL('../assets/cats/washing-face.svg', import.meta.url),
  new URL('../assets/cats/chin-on-paws.svg', import.meta.url),
];

const button = document.getElementById('cat-drawing');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const historyKey = 'portfolio-cat-history';
const historyLimit = Math.min(10, drawings.length - 1);
let recent = [];
let version = 0;
let animations = [];

function readHistory() {
  try {
    const saved = JSON.parse(window.localStorage.getItem(historyKey) || '[]');
    if (Array.isArray(saved)) {
      recent = saved.filter((index, position) =>
        Number.isInteger(index) && index >= 0 && index < drawings.length &&
        saved.lastIndexOf(index) === position,
      ).slice(-historyLimit);
    }
  } catch {
    // Keep an in-memory history when browser storage is unavailable or invalid.
  }
  return recent;
}

function rememberCat(index) {
  recent = [...readHistory().filter(previous => previous !== index), index].slice(-historyLimit);
  try {
    window.localStorage.setItem(historyKey, JSON.stringify(recent));
  } catch {
    // Drawing still works when the browser blocks persistent storage.
  }
}

function stopDrawing() {
  animations.forEach(animation => animation.cancel());
  animations = [];
  button.querySelectorAll('path').forEach(path => {
    path.style.removeProperty('stroke-dasharray');
    path.style.removeProperty('stroke-dashoffset');
  });
}

function finishDrawing() {
  stopDrawing();
  button.dataset.state = 'ready';
}

function draw(svg) {
  if (reducedMotion.matches || !Element.prototype.animate) {
    finishDrawing();
    return;
  }

  const ticket = version;
  const strokes = [...svg.querySelectorAll('path')].map(path => ({
    path,
    length: Math.max(path.getTotalLength(), 1),
  }));
  const totalWeight = strokes.reduce((sum, stroke) => sum + stroke.length + 20, 0);
  let delay = 0;
  button.dataset.state = 'drawing';

  animations = strokes.map(({ path, length }) => {
    const duration = 2600 * (length + 20) / totalWeight;
    path.style.strokeDasharray = `${length} ${length}`;
    path.style.strokeDashoffset = String(length);
    const animation = path.animate(
      [{ strokeDashoffset: String(length) }, { strokeDashoffset: '0' }],
      { duration, delay, easing: 'linear', fill: 'forwards' },
    );
    delay += duration;
    return animation;
  });

  Promise.all(animations.map(animation => animation.finished))
    .then(() => { if (ticket === version) finishDrawing(); })
    .catch(() => {}); // A new cat or reduced-motion change cancels the old drawing.
}

async function chooseCat() {
  const ticket = ++version;
  button.dataset.state = 'loading';
  stopDrawing();
  const history = readHistory();
  const available = drawings.map((_, index) => index).filter(index => !history.includes(index));
  const selected = available[Math.floor(Math.random() * available.length)];

  try {
    const response = await fetch(drawings[selected]);
    if (!response.ok) throw new Error('Cat drawing unavailable');
    const document = new DOMParser().parseFromString(await response.text(), 'image/svg+xml');
    if (ticket !== version) return;
    const svg = document.documentElement;
    if (svg.localName !== 'svg') throw new Error('Invalid cat drawing');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    svg.removeAttribute('aria-labelledby');
    svg.removeAttribute('role');
    button.replaceChildren(svg);
    rememberCat(selected);
    draw(svg);
  } catch {
    // Keep the complete inline cat visible if loading the selected asset fails.
    if (ticket === version) finishDrawing();
  }
}

if (button) {
  button.addEventListener('click', chooseCat);
  reducedMotion.addEventListener('change', () => {
    if (reducedMotion.matches && button.dataset.state === 'drawing') finishDrawing();
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted && button.dataset.state === 'drawing') finishDrawing();
  });
  chooseCat();
}
